import { useQuizContext } from "./QuizContext";

export function useQuiz() {
  const { state, dispatch } = useQuizContext();

  const dogs = state.dogOrder.map((id) => ({
    id,
    form: state.dogForms[id] || {},
  }));

  const activeDogId = state.activeDogId;

  const setActiveDog = (id: string | null) => {
    dispatch({ type: "SET_ACTIVE_DOG", dogId: id });
  };

  const addDog = () => {
    dispatch({ type: "ADD_DOG" });
  };

  const removeDog = (dogId: string) => {
    dispatch({ type: "REMOVE_DOG", dogId });
  };

  const setDogsCount = (count: number) => {
    dispatch({ type: "SET_DOGS_COUNT", count });
  };

  return {
    dogs,
    activeDogId,
    setActiveDog,
    addDog,
    removeDog,
    setDogsCount,
    dogsCountConfirmed: !!state.dogsCountConfirmed,
  };
}
